var uiAssetClassBadge = {
	bond: "Anleihe",
	commodity: "Rohstoff",
	currency: "Währung",
	debt: "Schuldtitel",
	etf: "ETF",
	fund: "Fonds",
	generic: "Sonstige",
	index: "Index",
	stock: "Aktie",
	interestRate: "Zinssatz",
	structuredProduct: "Strukturiertes Produkt",
	investmentProduct: "Anlageprodukt",
	leveragedProduct: "Hebelprodukt",
	future: "Future",
	option: "Option"
};
var de = {
	uiAssetClassBadge: uiAssetClassBadge
};

export { de as default, uiAssetClassBadge };
